import { useReducer } from "react"
import { incByfiveoo ,incBytwo , decByfiveoo,decBytwo}  from "./CounterDispatch"
import reducer from "./Counteraction"
function Counter(){
   const [state,dispatch] = useReducer(reducer,{
    amount:0
})
    return(
        <>
            <h1>Count : {state.amount}</h1>
            <button onClick={()=>dispatch(incByfiveoo)}>INC BY 1000</button>
            <button onClick={()=>dispatch(incBytwo)}>INC BY 2000</button>
            <button onClick={()=>dispatch(decByfiveoo)}>DEC BY 1000</button>
            <button onClick={()=>dispatch(decBytwo)}>DEC BY 2000</button>
        </>
    )
}
export default Counter